// extracted by mini-css-extract-plugin
export var card = "_n5-1";
export var summary = "_n5-0";
export var unreadDot = "_n5-2";